import { render } from "./ReportCriterionDateRange.vue?vue&type=template&id=036345af&scoped=true"
import script from "./ReportCriterionDateRange.vue?vue&type=script&lang=js"
export * from "./ReportCriterionDateRange.vue?vue&type=script&lang=js"

import "./ReportCriterionDateRange.vue?vue&type=style&index=0&id=036345af&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036345af"]])

export default __exports__